// extracted by mini-css-extract-plugin
module.exports = {"form":"FormMovieSearch_form__Iapma","inputSearchMovie":"FormMovieSearch_inputSearchMovie__1y4RU"};